export default "__VITE_ASSET__CV9ImTFk__"